import { computed, Injectable, signal } from '@angular/core';

import { Capacitor } from '@capacitor/core';

import {
  BREAKPOINT_LG_QUERY,
  BREAKPOINT_MD_QUERY,
  BREAKPOINT_XL_QUERY,
} from '@core/constants/breakpoints';

@Injectable({ providedIn: 'root' })
export class ScreenStore {
  private readonly isNative = Capacitor.isNativePlatform();
  private readonly mobileSignal = signal(this.checkQuery(BREAKPOINT_MD_QUERY, true));
  private readonly lgSignal = signal(this.checkQuery(BREAKPOINT_LG_QUERY));
  private readonly xlSignal = signal(this.checkQuery(BREAKPOINT_XL_QUERY));

  readonly isMobile = this.mobileSignal.asReadonly();
  readonly isDesktop = computed(() => !this.mobileSignal());
  readonly isTablet = computed(() => !this.mobileSignal() && !this.lgSignal());
  readonly isLaptop = computed(() => this.lgSignal() && !this.xlSignal());
  readonly showBottomNav = computed(() => this.isMobile() || this.isTablet());

  constructor() {
    if (this.isNative) {
      return;
    }

    this.listenToQuery(BREAKPOINT_MD_QUERY, (matches) => this.mobileSignal.set(!matches));
    this.listenToQuery(BREAKPOINT_LG_QUERY, (matches) => this.lgSignal.set(matches));
    this.listenToQuery(BREAKPOINT_XL_QUERY, (matches) => this.xlSignal.set(matches));
  }

  private checkQuery(query: string, invert = false): boolean {
    if (this.isNative) {
      return invert;
    }

    const matches = window.matchMedia(query).matches;
    return invert ? !matches : matches;
  }

  private listenToQuery(query: string, callback: (matches: boolean) => void): void {
    window.matchMedia(query).addEventListener('change', (event) => {
      callback(event.matches);
    });
  }
}
